import * as THREE from "three";
import predefinedTextures from "./global-textures.json";
import { patchArray } from "../utils/data-utils";

const textures = [
  {
    id: "showroom",
    preload: true,
    file: { url: "textures/showroom.jpg" },
    mapping: THREE.EquirectangularReflectionMapping,
    wrapS: THREE.ClampToEdgeWrapping,
    wrapT: THREE.ClampToEdgeWrapping,
    encoding: THREE.sRGBEncoding,
    minFilter: THREE.LinearFilter,
  },
  /* {
    id: "showroom_env",
    preload: true,
    file: { url: "textures/showroom_env.jpg" },
    mapping: THREE.EquirectangularReflectionMapping,
    wrapS: THREE.ClampToEdgeWrapping,
    wrapT: THREE.ClampToEdgeWrapping,
    encoding: THREE.LinearEncoding,
    minFilter: THREE.LinearFilter,
  }, */
  {
    id: "field",
    preload: true,
    file: { url: "textures/field.jpg" },
    mapping: THREE.EquirectangularReflectionMapping,
    wrapS: THREE.ClampToEdgeWrapping,
    wrapT: THREE.ClampToEdgeWrapping,
    encoding: THREE.sRGBEncoding,
    minFilter: THREE.LinearFilter,
  },
  /* {
    id: "field_env",
    preload: true,
    file: { url: "textures/field_env.jpg" },
    mapping: THREE.EquirectangularReflectionMapping,
    wrapS: THREE.ClampToEdgeWrapping,
    wrapT: THREE.ClampToEdgeWrapping,
    encoding: THREE.sRGBEncoding,
    minFilter: THREE.LinearFilter,
  }, */
  {
    id: "flakes",
    preload: true,
    type: "FlakesTexture",
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    repeat: [80, 80],
    anisotropy: 16,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_flakes_150_150",
    preload: true,
    type: "FlakesTexture",
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    repeat: [200, 200],
    anisotropy: 16,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_flakes_75_75",
    preload: true,
    type: "FlakesTexture",
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    repeat: [50, 50],
    anisotropy: 16,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Grime_1",
    file: { url: "textures/T_Grime_1_lite.jpg" },
    repeat: [6, 6],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Grime_1_lite",
    file: { url: "textures/T_Grime_1_lite.jpg" },
    repeat: [6, 6],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Grime_2",
    file: { url: "textures/T_Grime_2.jpg" },
    repeat: [10, 10],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Tail_Light_lens",
    file: { url: "textures/T_Tail_Light_lens.jpg" },
    repeat: [150, 150],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Round_Grid",
    file: { url: "textures/T_Round_Grid.jpg" },
    repeat: [400, 400],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Round_Grid_O",
    file: { url: "textures/T_Round_Grid_O.jpg" },
    repeat: [400, 400],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Radiator",
    file: { url: "textures/T_Radiator.jpg" },
    repeat: [120, 120],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_checker_BW_treads",
    file: { url: "textures/T_checker_BW_2.jpg" },
    repeat: [10, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
   {
    id: "T_Carbon",
    file: { url: "textures/T_checker_BW.jpg" },
    repeat: [450, 450],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  }, 
/*    {
    id: "T_Unlimited_Pattern",
    file: { url: "textures/T_Unlimited_Pattern.jpg" },
    repeat: [3, 3],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },  */
    {
    id: 'T_Light_Strip',
    file: { url: 'textures/T_checker_BW_1.jpg' },
    repeat: [300, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  }, 
  {
    id: "T_Tyri_Aux_light_lens",
    file: { url: "textures/T_Tyri_Aux_light_lens.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Hella_SML_MD1224",
    file: { url: "textures/T_Hella_SML_MD1224.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Projector_lens",
    file: { url: "textures/T_Projector_lens.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Steeringwheel_B",
    file: { url: "textures/T_Steeringwheel_B.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Steeringwheel_R",
    file: { url: "textures/T_Steeringwheel_R.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Steeringwheel_N",
    file: { url: "textures/T_Steeringwheel_N.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_M219VV2550110_N",
    file: { url: "textures/T_M219VV2550110_N.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Speaker_Grid_O",
    file: { url: "textures/T_Speaker_Grid_O.jpg" },
    repeat: [14, 14],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Speaker_Grid_B",
    file: { url: "textures/T_Speaker_Grid_Bump.jpg" },
    repeat: [14, 14],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Felt",
    file: { url: "textures/T_Felt.jpg" },
    repeat: [30, 30],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Instrument_Cluster",
    file: { url: "textures/T_Instrument_Cluster.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Speaker_B",
    file: { url: "textures/T_Speaker_B.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Fabric_Aux_Seat",
    file: { url: "textures/T_Fabric_Aux_Seat.jpg" },
    repeat: [40, 40],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Fabric",
    file: { url: "textures/T_Fabric.jpg" },
    repeat: [10, 10],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Leather_1",
    file: { url: "textures/T_Leather_1.jpg" },
    repeat: [5, 5],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_TM800_N",
    file: { url: "textures/T_TM800_N.png" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_TM800_ORM",
    file: { url: "textures/T_TM800_ORM.png" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_AC65_N",
    file: { url: "textures/T_AC65_N.png" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_AC65_ORM",
    file: { url: "textures/T_AC65_ORM.png" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_Felt_White_N_T_AO",
    file: { url: "textures/M_Felt_white_N_T_AO.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
  {
    id: "T_AGCO-Valtra-Middle line_Styling_LED ON",
    file: { url: "textures/AGCO-Valtra-Middle line_Styling_LED ON.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
 {
    id: "T_ACX3203580_GFX_2",
    file: { url: "textures/T_ACX3203580_GFX_2.jpg" },
    repeat: [1, 1],
    wrapS: THREE.RepeatWrapping,
    wrapT: THREE.RepeatWrapping,
    encoding: THREE.sRGBEncoding,
  },
];

export default patchArray(predefinedTextures, textures);
